import TrademarkFooter from "./TrademarkFooter";
export default TrademarkFooter;
